<ng-container *skAutorun><sk-rich-text [html]="html"></sk-rich-text></ng-container>